module.exports = __webpack_public_path__ + "static/flags/NT-4ad91e5df4873d9b1de23fc88d45e52e.gif";